<template>
  <div id="app" v-bind:class="{ maximized: maximized }">
    <a href="#" class="minimize" v-on:click="maximized = !maximized">
      <i class="fa fa-compress" aria-hidden="true" v-if="!maximized"></i>
      <i class="fa fa-expand" aria-hidden="true" v-if="maximized"></i>
    </a>
    <div class="sidebar">
      <img :src="imageUrl" style="max-width: 100%" alt="" />
      <HelloWorld :items="items" />

      <a class="logout" href="/task:login.logout">Logout</a>
    </div>
    <div class="iframeContainer">
      <iframe
        :src="iframeUrl"
        :width="iframeWidth"
        :height="iframeHeight"
        border="0"
      />
    </div>
  </div>
</template>
<script>
import HelloWorld from "./HelloWorld.vue";
import { mapState } from "vuex";
export default {
  components: {
    HelloWorld
  },

  data: function() {
    return {
      maximized: false
    };
  },
  computed: mapState({
    items: state => state.data.items,
    imageUrl: () => {
      let path = window.location.pathname;
      if (path.indexOf(":") > 0) {
        path = path.substring(0, path.lastIndexOf("/"));
      }
      return path + "/logo.jpg";
    },
    iframeUrl: state => state.iframeUrl,
    iframeWidth: state => state.iframeWidth,
    iframeHeight: state => state.iframeHeight
  })
};
</script>

<style lang="scss">
.minimize {
  color: white;
  font-size: 20px;
  position: absolute;
  top: 2px;
  left: 2px;
  z-index: 1500;
  background: rgba(0, 0, 0.4);
  padding: 0 5px;
  border-radius: 5px;
}
body {
  background: #2e2d33;
}
.nano-content {
  padding: 0 0;
}
.main {
  height: 100%;
  padding-left: 230px;
}

li.sub-menu a {
  font-size: 18px;
  font-weight: bold;
}
.iframeContainer {
  padding-left: 240px;
}
.logo-container {
  height: 100px;
  padding: 5px;
  background: white;
  border-right: 1px solid black;
  display: flex;
  align-items: center;
  justify-content: center;
}
.logo-container img {
  max-width: 100%;
}
.sidebar {
  width: 240px;
  height: 100vh;
  background: #293949;
  position: fixed;
  overflow-y: auto;
  overflow-x: hide;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  z-index: 100;
}
.sidebar #leftside-navigation {
  max-height: 100vh;
  overflow: auto;
}
.sidebar #leftside-navigation ul,
.sidebar #leftside-navigation ul ul {
  margin: -2px 0 0;
  padding: 0;
}
.sidebar #leftside-navigation ul li {
  list-style-type: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}
.sidebar #leftside-navigation ul li.active > a {
  color: #1abc9c;
}
li.active > a {
  color: #1abc9c;
}
.sidebar #leftside-navigation ul li.active ul {
  display: block;
}
.sidebar #leftside-navigation ul li a {
  color: #aeb2b7;
  text-decoration: none;
  display: block;
  padding: 10px 0 10px 20px;
  font-size: 14px;
  font-weight: bold;
  outline: 0;
  -webkit-transition: all 200ms ease-in;
  -moz-transition: all 200ms ease-in;
  -o-transition: all 200ms ease-in;
  -ms-transition: all 200ms ease-in;
  transition: all 200ms ease-in;
}
.sidebar #leftside-navigation ul li a:hover {
  color: #1abc9c;
}
.sidebar #leftside-navigation ul li a span {
  display: inline-block;
}
.sidebar #leftside-navigation ul li a i {
  width: 20px;
}
.sidebar #leftside-navigation ul li a i .fa-angle-left,
.sidebar #leftside-navigation ul li a i .fa-angle-right {
  padding-top: 3px;
}
.sidebar #leftside-navigation ul ul {
  display: none;
}
.sidebar #leftside-navigation ul ul li {
  background: #23313f;
  margin-bottom: 0;
  margin-left: 0;
  margin-right: 0;
  border-bottom: none;
}
.sidebar #leftside-navigation ul ul li a {
  font-size: 12px !important;
  font-weight: normal !important;
  padding-top: 13px;
  padding-bottom: 13px;
  color: #aeb2b7;
}

.login-status a {
  padding-top: 20px;
  color: rgba(255, 255, 255, 0.4) !important;
}
.centeredImage {
  max-width: 200px;
  position: fixed;
  top: 50%;
  left: 50%;
  /* bring your own prefixes */
  transform: translate(-50%, -50%);
}
.maximized {
  .iframeContainer {
    padding-left: 0px;
  }
  .sidebar {
    display: none;
  }
}
@import url("//netdna.bootstrapcdn.com/font-awesome/4.0.3/css/font-awesome.min.css");
@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 300;
  src: local("Open Sans Light"), local("OpenSans-Light"),
    url(https://fonts.gstatic.com/s/opensans/v15/mem5YaGs126MiZpBA-UN_r8OUuhs.ttf)
      format("truetype");
}
@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  src: local("Open Sans Regular"), local("OpenSans-Regular"),
    url(https://fonts.gstatic.com/s/opensans/v15/mem8YaGs126MiZpBA-UFVZ0e.ttf)
      format("truetype");
}
@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 700;
  src: local("Open Sans Bold"), local("OpenSans-Bold"),
    url(https://fonts.gstatic.com/s/opensans/v15/mem5YaGs126MiZpBA-UN7rgOUuhs.ttf)
      format("truetype");
}
body {
  color: #5d5f63;
  font-family: "Open Sans", sans-serif;
  padding: 0;
  margin: 0;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
}

hr {
  margin: 0;
  border: 1px solid #18222b;
}

ul {
  border-top: 1px solid grey;
}
#app {
}
.logout {
  padding-top: 5px;
  padding-bottom: 5px;
  width: 100%;
  display: inline-block;
  border-top: 1px solid white;
  border-bottom: 1px solid white;
  color: white;
  text-decoration: none;
  text-align: center;
}
</style>
